import { createSlice } from "@reduxjs/toolkit";
import {
  getMasterDataByUserId,
  getProposedClassList,
  submitMasterData,
  updateMasterData,
} from "./masterDataThunk";

const masterDataSlice = createSlice({
  name: "masterData",
  initialState: {
    schoolName: "",
    school_id: "",
    schoolCategory: "",
    workingDays:null,
    summer: {
      schoolStart: "",
      schoolEnd: "",
      assemblyStart: "",
      assemblyEnd: "",
      months: [],
    },
    winter: {
      schoolStart: "",
      schoolEnd: "",
      assemblyStart: "",
      assemblyEnd: "",
      months: [],
    },
    logo: null,
    headers: [],
    proposedClassesList: [],
    selectedClasses: [],
    address: "",
    loading: false,
    error: null,
    isUpdate: false,
  },
  reducers: {
    updateField: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    updateSeasonField: (state, action) => {
      const { season, field, value } = action.payload;
      state[season][field] = value;
    },
    setLogo: (state, action) => {
      state.logo = action.payload;
    },
    setHeaderFiles: (state, action) => {
      state.headers = action.payload;
    },
     setSelectedClasses: (state, action) => {
      state.selectedClasses = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitMasterData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitMasterData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(submitMasterData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getMasterDataByUserId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMasterDataByUserId.fulfilled, (state, action) => {
    
        const data = action.payload;
        // if (data) {
        //   state.schoolName = data?.school_name;
        //   const summer = JSON.parse(data.summer_timings);
        //   state.summer.schoolStart = summer.schoolStart;
        //   state.summer.schoolEnd = summer.schoolEnd;
        //   state.summer.assemblyStart = summer.assemblyStart;
        //   state.summer.assemblyEnd = summer.assemblyEnd;
        //   const winter = JSON.parse(data.winter_timings);
        //   state.winter.schoolStart = winter.schoolStart;
        //   state.winter.schoolEnd = winter.schoolEnd;
        //   state.winter.assemblyStart = winter.assemblyStart;
        //   state.winter.assemblyEnd = winter.assemblyEnd;
        // }
        if (data) {
          state.isUpdate = true;
          state.schoolName = data.school_name;
          state.school_id = data.school_id;
          state.address = data.address || "";
          state.website = data.website || "";
          state.email = data.email || "";
          state.contactNumber = data.contact_number || "";
          state.altNumber = data.alt_number || "";
          state.logo = data.logo_url || null;
          state.headers = data.header_files_urls || [];
          state.schoolCategory=data.school_category || "";
          state.selectedClasses=data.selected_classes || [];
          state.workingDays = data.working_days; // Default to 5 if not provided
          if (data.summer_timings) {
            try {
              const summer = JSON.parse(data.summer_timings);
              state.summer.schoolStart = summer.schoolStart || "";
              state.summer.schoolEnd = summer.schoolEnd || "";
              state.summer.assemblyStart = summer.assemblyStart || "";
              state.summer.assemblyEnd = summer.assemblyEnd || "";
              state.summer.months = Array.isArray(summer.months) ? summer.months : [];

              if (summer.breakTimings && Array.isArray(summer.breakTimings)) {
                state.summer.breakTimings = summer.breakTimings.map(
                  (timing) => ({
                    start: timing.start || "",
                    end: timing.end || "",
                  })
                );
              } else {
                state.summer.breakTimings = [];
              }
            } catch (error) {
              console.error("Error parsing summer timings:", error);
            }
          }
          if (data.winter_timings) {
            try {
              const winter = JSON.parse(data.winter_timings);
              state.winter.schoolStart = winter.schoolStart || "";
              state.winter.schoolEnd = winter.schoolEnd || "";
              state.winter.assemblyStart = winter.assemblyStart || "";
              state.winter.assemblyEnd = winter.assemblyEnd || "";
              state.winter.months = Array.isArray(winter.months) ? winter.months : [];

              if (winter.breakTimings && Array.isArray(winter.breakTimings)) {
                state.winter.breakTimings = winter.breakTimings.map(
                  (timing) => ({
                    start: timing.start || "",
                    end: timing.end || "",
                  })
                );
              } else {
                state.winter.breakTimings = [];
              }
            } catch (error) {
              console.error("Error parsing winter timings:", error);
            }
          }
        }
            state.loading = false;
      })
      .addCase(getMasterDataByUserId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateMasterData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMasterData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateMasterData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       .addCase(getProposedClassList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProposedClassList.fulfilled, (state, action) => {
        state.loading = false;
        state.proposedClassesList = action.payload; // Set proposed classes
      })
      .addCase(getProposedClassList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export const { updateField, updateSeasonField, setLogo, setHeaderFiles,setSelectedClasses } =
  masterDataSlice.actions;
export default masterDataSlice.reducer;
